export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-female-symbol-6ae79f36bdfd8d2f6ae9cbafd5fe0d02.svg";